// PackageScreen.js
import React, {useState} from 'react';
import {
  View,
  Text,
  StyleSheet,
  ScrollView,
  TouchableOpacity,
} from 'react-native';
import Icon from 'react-native-vector-icons/MaterialIcons';

const PackageScreen = () => {
  const [selectedPackage, setSelectedPackage] = useState(null);

  const packages = [
    {
      id: 1,
      title: 'বেসিক প্যাকেজ',
      price: '২৯৯',
      duration: '১ মাস',
      features: [
        'অসীম আইন অনুসন্ধান',
        '৫টি দলিল প্রস্তুত',
        'ইমেইল সাপোর্ট',
        'বেসিক পরামর্শ সেবা',
      ],
      color: '#4CAF50',
      popular: false,
    },
    {
      id: 2,
      title: 'স্ট্যান্ডার্ড প্যাকেজ',
      price: '৪৯৯',
      duration: '৩ মাস',
      features: [
        'অসীম আইন অনুসন্ধান',
        '১৫টি দলিল প্রস্তুত',
        '২৪/৭ ফোন সাপোর্ট',
        'অগ্রাধিকার পরামর্শ',
        'আইন গবেষণা সেবা',
      ],
      color: '#307ecc',
      popular: true,
    },
    {
      id: 3,
      title: 'প্রিমিয়াম প্যাকেজ',
      price: '৯৯৯',
      duration: '৬ মাস',
      features: [
        'অসীম আইন অনুসন্ধান',
        'অসীম দলিল প্রস্তুত',
        'ব্যক্তিগত আইনজীবী',
        '২৪/৭ প্রায়োরিটি সাপোর্ট',
        'আপিল সহায়তা',
        'সাক্ষর প্রমাণ সংরক্ষণ',
      ],
      color: '#FF6B6B',
      popular: false,
    },
  ];

  const handleSubscribe = packageId => {
    setSelectedPackage(packageId);
    // Navigate to payment or show confirmation
  };

  return (
    <ScrollView style={styles.container} showsVerticalScrollIndicator={false}>
      <View style={styles.header}>
        <Text style={styles.headerTitle}>আমাদের প্যাকেজসমূহ</Text>
        <Text style={styles.headerSubtitle}>
          আপনার চাহিদা অনুযায়ী সঠিক প্যাকেজ নির্বাচন করুন
        </Text>
      </View>
      <View style={styles.container_body}>
        <View style={styles.packagesContainer}>
          {packages.map(pkg => (
            <TouchableOpacity
              key={pkg.id}
              style={[
                styles.packageCard,
                selectedPackage === pkg.id && styles.packageCardSelected,
                pkg.popular && styles.packageCardPopular,
              ]}
              onPress={() => handleSubscribe(pkg.id)}
              activeOpacity={0.9}
            >
              {pkg.popular && (
                <View style={styles.popularBadge}>
                  <Text style={styles.popularBadgeText}>জনপ্রিয়</Text>
                </View>
              )}

              <View style={styles.packageHeader}>
                <Text style={styles.packageTitle}>{pkg.title}</Text>
                <View style={[styles.priceBadge, {backgroundColor: pkg.color}]}>
                  <Text style={styles.priceCurrency}>৳</Text>
                  <Text style={styles.priceText}>{pkg.price}</Text>
                  <Text style={styles.priceDuration}>/{pkg.duration}</Text>
                </View>
              </View>

              <View style={styles.featuresContainer}>
                {pkg.features.map((feature, index) => (
                  <View key={index} style={styles.featureRow}>
                    <Icon name="check-circle" size={20} color={pkg.color} />
                    <Text style={styles.featureText}>{feature}</Text>
                  </View>
                ))}
              </View>

              <TouchableOpacity
                style={[
                  styles.subscribeButton,
                  {backgroundColor: pkg.color},
                  selectedPackage === pkg.id && styles.subscribeButtonActive,
                ]}
                onPress={() => handleSubscribe(pkg.id)}
              >
                <Text style={styles.subscribeButtonText}>
                  {selectedPackage === pkg.id
                    ? 'নির্বাচিত'
                    : 'সাবস্ক্রাইব করুন'}
                </Text>
              </TouchableOpacity>
            </TouchableOpacity>
          ))}
        </View>

        {/* Comparison Table */}
        <View style={styles.comparisonContainer}>
          <Text style={styles.comparisonTitle}>প্যাকেজ তুলনা</Text>
          <View style={styles.comparisonTable}>
            <View style={styles.comparisonRow}>
              <Text style={styles.comparisonLabel}>বৈশিষ্ট্য</Text>
              <Text style={styles.comparisonValue}>বেসিক</Text>
              <Text style={styles.comparisonValue}>স্ট্যান্ডার্ড</Text>
              <Text style={styles.comparisonValue}>প্রিমিয়াম</Text>
            </View>
            <View style={styles.comparisonRow}>
              <Text style={styles.comparisonLabel}>আইন অনুসন্ধান</Text>
              <Icon name="check" size={20} color="#4CAF50" />
              <Icon name="check" size={20} color="#307ecc" />
              <Icon name="check" size={20} color="#FF6B6B" />
            </View>
            <View style={styles.comparisonRow}>
              <Text style={styles.comparisonLabel}>দলিল প্রস্তুত</Text>
              <Text style={styles.comparisonValue}>৫টি</Text>
              <Text style={styles.comparisonValue}>১৫টি</Text>
              <Text style={styles.comparisonValue}>অসীম</Text>
            </View>
            <View style={styles.comparisonRow}>
              <Text style={styles.comparisonLabel}>সাপোর্ট</Text>
              <Text style={styles.comparisonValue}>ইমেইল</Text>
              <Text style={styles.comparisonValue}>ফোন</Text>
              <Text style={styles.comparisonValue}>প্রায়োরিটি</Text>
            </View>
            <View style={[styles.comparisonRow, styles.comparisonRowLast]}>
              <Text style={styles.comparisonLabel}>দাম</Text>
              <Text style={styles.comparisonPrice}>২৯৯</Text>
              <Text style={styles.comparisonPrice}>৪৯৯</Text>
              <Text style={styles.comparisonPrice}>৯৯৯</Text>
            </View>
          </View>
        </View>
      </View>
    </ScrollView>
  );
};

const styles = StyleSheet.create({
  container: {
    flex: 1,
    backgroundColor: '#f5f5f5',
  },
  container_body: {
    flex: 1,
    paddingHorizontal: 40,
  },
  header: {
    backgroundColor: '#307ecc',
    padding: 10,
    paddingTop: 10,
    paddingLeft: 40,
    // paddingBottom: 30,
  },
  headerTitle: {
    fontSize: 24,
    fontWeight: 'bold',
    color: '#fff',
  },
  headerSubtitle: {
    fontSize: 14,
    color: '#fff',
    opacity: 0.9,
    marginTop: 4,
  },
  packagesContainer: {
    padding: 15,
  },
  packageCard: {
    backgroundColor: '#fff',
    borderRadius: 16,
    padding: 20,
    marginBottom: 15,
    shadowColor: '#000',
    shadowOffset: {width: 0, height: 2},
    shadowOpacity: 0.08,
    shadowRadius: 6,
    elevation: 3,
    position: 'relative',
  },
  packageCardSelected: {
    borderWidth: 2,
    borderColor: '#307ecc',
  },
  packageCardPopular: {
    shadowColor: '#307ecc',
    shadowOpacity: 0.2,
    shadowRadius: 10,
    elevation: 6,
  },
  popularBadge: {
    position: 'absolute',
    top: -10,
    right: -10,
    backgroundColor: '#FF6B6B',
    paddingHorizontal: 12,
    paddingVertical: 4,
    borderRadius: 20,
    zIndex: 1,
  },
  popularBadgeText: {
    color: '#fff',
    fontSize: 12,
    fontWeight: 'bold',
  },
  packageHeader: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
    marginBottom: 15,
  },
  packageTitle: {
    fontSize: 20,
    fontWeight: 'bold',
    color: '#333',
  },
  priceBadge: {
    flexDirection: 'row',
    alignItems: 'baseline',
    paddingHorizontal: 12,
    paddingVertical: 6,
    borderRadius: 20,
  },
  priceCurrency: {
    fontSize: 14,
    color: '#fff',
    fontWeight: 'bold',
  },
  priceText: {
    fontSize: 22,
    color: '#fff',
    fontWeight: 'bold',
  },
  priceDuration: {
    fontSize: 12,
    color: '#fff',
    opacity: 0.9,
  },
  featuresContainer: {
    marginBottom: 15,
  },
  featureRow: {
    flexDirection: 'row',
    alignItems: 'center',
    marginBottom: 6,
  },
  featureText: {
    fontSize: 14,
    color: '#555',
    marginLeft: 8,
  },
  subscribeButton: {
    paddingVertical: 12,
    borderRadius: 8,
    alignItems: 'center',
  },
  subscribeButtonActive: {
    opacity: 0.7,
  },
  subscribeButtonText: {
    color: '#fff',
    fontSize: 16,
    fontWeight: 'bold',
  },
  comparisonContainer: {
    backgroundColor: '#fff',
    margin: 15,
    padding: 15,
    borderRadius: 12,
    marginBottom: 30,
    shadowColor: '#000',
    shadowOffset: {width: 0, height: 2},
    shadowOpacity: 0.08,
    shadowRadius: 4,
    elevation: 2,
  },
  comparisonTitle: {
    fontSize: 18,
    fontWeight: 'bold',
    color: '#333',
    marginBottom: 12,
    textAlign: 'center',
  },
  comparisonTable: {
    borderWidth: 1,
    borderColor: '#e0e0e0',
    borderRadius: 8,
    overflow: 'hidden',
  },
  comparisonRow: {
    flexDirection: 'row',
    justifyContent: 'space-around',
    alignItems: 'center',
    paddingVertical: 10,
    paddingHorizontal: 8,
    borderBottomWidth: 1,
    borderBottomColor: '#e0e0e0',
  },
  comparisonRowLast: {
    borderBottomWidth: 0,
  },
  comparisonLabel: {
    fontSize: 13,
    fontWeight: '600',
    color: '#333',
    flex: 1.5,
  },
  comparisonValue: {
    fontSize: 12,
    color: '#666',
    flex: 1,
    textAlign: 'center',
  },
  comparisonPrice: {
    fontSize: 14,
    fontWeight: 'bold',
    color: '#307ecc',
    flex: 1,
    textAlign: 'center',
  },
});

export default PackageScreen;
